import { reactLocalStorage } from 'reactjs-localstorage';

import Header from './Headers';
import ExtenalHeaders from './ExtenalHeaders';
import Const from '../util/Constants';
import Util from '../util/Util';
import Config from '../config/config';

class CallAPI {

  static getList = (list, success, failure) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    const sorting = list.sorting;
    const body = { filter, page, perPage, sorting };
    fetch(Config.app.link + 'api/call/list', new Header('POST',  body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static count = (list, success, failure) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    fetch(Config.app.link + 'api/call/list/count', new Header('POST',  { filter, page, perPage }))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static getInnerList = (modelType, modelId, success, failure, Restrict, User) => {
    const filter = [{field: 'model', type: 'model', "condition": "equals",
    value: `${modelType}~${modelId}`}];
    if(Restrict) {
      filter.push({field: 'responsible_person', type: 'multiselect~user', condition: 'equals', value: User});
    }
    const page = 1;
    const perPage = 1000;
    const sorting = undefined;
    const body = { filter, page, perPage, sorting };
    fetch(Config.app.link + 'api/call/list', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (call, success, failure) => {
    fetch(Config.app.link + 'api/call/add-edit', new Header('POST', call))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/call/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static massUpdate = (list, selected, updates, success, failure) => {
    const filter = list.filters;
    const body = { filter: filter, selected, updates };
    
    fetch(Config.app.link + 'api/call/mass-update', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static cloudCall = (phone, call, model_no, model_id, success, failure) => {
    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    const CloudCallAPI = reactLocalStorage.getObject(Const.CloudCalling);

    if(CloudCallAPI.party_type === Const.TeleCMI) {
      new Promise(async (resolve, reject) => {
        const body = {
          user_id: CloudCallAPI.user_id,
          secret: CloudCallAPI.secret,
          to: parseFloat(`91${phone}`),
          extra_params: { "crm": true },
          webrtc: true,
          followme: false,
          callerid: parseFloat(CloudCallAPI.callerid)
        };

        const res = await fetch('https://rest.telecmi.com/v2/webrtc/click2call', new Header('POST', body));
        try {
          const resJson = await res.json();
          call = call
          ? { 
            ...call,
            call_mode: Const.CallStatusDialerCloudCall
          }
          : { 
            id: 0, 
            direction: 2, 
            date_time: Util.dateToServerDateTime(new Date()),
            feedback: 0, 
            comment:'', 
            responsible_person: user.user_id, 
            complete: 0, 
            model_no, 
            model_id,
            ccid: resJson.request_id,
            call_mode: Const.CallStatusDialerCloudCall
          };
          CallAPI.save(call, success, failure);
        } catch(err) {
          console.log('err', err);
          reject();
        }
      }).then(success, failure);
    } else {
      const CloudCall = {
        cloud: { ...CloudCallAPI, client_phone: phone },
        call:  call
        ? { 
          ...call,
          call_mode: Const.CallStatusDialerCloudCall
        }
        : { 
          id: 0, 
          direction: 2, 
          date_time: Util.dateToServerDateTime(new Date()),
          feedback: 0, 
          comment:'', 
          responsible_person: user.user_id, 
          complete: 0, 
          model_no, 
          model_id,
          call_mode: Const.CallStatusDialerCloudCall
        }
      };
  
      fetch(Config.app.link + 'api/call/cloud', new Header('POST', CloudCall))
        .then(res => Const.ProcessAPI(res, success, failure)).catch(failure);
    }
  }

  static getFixedCallReportList = (filter, success, failure) => {
    const body = { filters : filter};
    fetch(Config.app.link + 'api/call-report/CallReport', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
  static getFixedCallStatusReportList = (filter, success, failure) => {
    const body = { filters : filter};
    fetch(Config.app.link + 'api/call-report/CallStatusReport', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
  static getFixedCallStatusByHourReportList = (filter, success, failure) => {
    const body = { filters : filter};
    fetch(Config.app.link + 'api/call-report/CallStatusByHourReport', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default CallAPI;